import { PLAYER } from "../types/players";
import { TEAM, teamOnePlayers } from "../types/teams";

export function getPlayersTeam(player: PLAYER): TEAM {
  if (teamOnePlayers.includes(player)) return TEAM.ONE;
  return TEAM.TWO;
}

export function getOpponentsTeam(player: PLAYER): TEAM {
  if (teamOnePlayers.includes(player)) return TEAM.TWO;
  return TEAM.ONE;
}